import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { WaxContext } from 'wax-prosemirror-core';
import { HuePicker, SketchPicker } from 'react-color';
import styled from 'styled-components';
import { AlignCenterOutlined, AlignLeftOutlined, AlignRightOutlined, BgColorsOutlined, EditOutlined, FontColorsOutlined, FontSizeOutlined, LineHeightOutlined, TableOutlined } from "@ant-design/icons";
import { toggleMark } from 'prosemirror-commands';
import { Transaction } from "prosemirror-state";


const Wrapper = styled.div`
  font-size: 0;
  position: relative;
  z-index: 2;
  padding:0px 3px;
`;

const DropWrapper = styled.div`
  background: white;
  margin-top: 20px;
  position: absolute;
  top: 32px;
  width: max-content;
  color:black;
`;

const DropWrapperBorderWidth = styled.div`
  background: white;
  margin-top: 20px;
  position: absolute;
  top: 32px;
  width: max-content;
  color:black;
`;

const Highlighter = styled.div`
  cursor: pointer;
  display: inline-grid;
  height: 20px;
  margin: 5px;
  margin-top:10px;
  min-width: 20px;
`;

const HighlighterBWidth = styled.div`
     cursor: pointer;
     display: inline-grid;
     height: 30px;
     width: 50px;
     margin: 5px;
     margin-top:10px;
     min-width: 20px;
`;

const HighlighterStyle = styled.div`
  cursor: pointer;
  padding:2px 5px;
  margin-top:10px;
  height:1px;
`;

const HighlighterStyleSize = styled.div`
cursor: pointer;
padding:2px 5px;
margin-top:10px;
height:20px;
display:flex;
flext-direction:row;
`;

const LineItems = styled.div`
 display:flex;
 flext-direction:column;
`;

const LineItemsBorder = styled.div`
 display:flex;
 flext-direction:column;
 padding: 5px;
`;

const TextHighlightComponent = styled.div`
     color:red;
     display: flex;
     flex-direction: column;
     width: 80px;
     height:fit-content;
     padding: 10px 10px 0px;
     box-sizing: initial;
     background: rgb(255, 255, 255);
     border-radius: 4px;
     box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px;
`;

const TextAlignmentComponent = styled.div`
     color:red;
     display: flex;
     flex-direction: row;
     height:150px;
     padding: 10px 10px 0px;
     box-sizing: initial;
     background: rgb(255, 255, 255);
     border-radius: 4px;
     box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px;
`;

const TextAlignmentComponentBorder = styled.div`
     color:black;
     display: flex;
     flex-direction: row;
     height:35px;
     padding: 10px 10px 0px;
     box-sizing: initial;
     background: rgb(255, 255, 255);
     border-radius: 4px;
     box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px;
`;

const StyledTextSize = styled.span`
  color: black;
  text-align: left;
  font-size:14px;
  margin: 4px 5px;
  cursor:pointer;
`;

const StyledText = styled.span`
  color: black;
  text-align: left;
  font-size:20px;
  margin: 1px 5px;
  cursor:pointer;
`;

const CustomTableStyle = () => {
     const {
          app,
          pmViews: { main },
          activeViewId,
          activeView,
          placeholderPlugin
     } = useContext(WaxContext);
     const [tableStyle, SettableStyle] = useState(false);
     const [borderWidth, SetborderWidth] = useState(false);
     const [borderLine, SetborderLine] = useState(false);
     const [borderColor, SetborderColor] = useState(false);
     const [colorLabel, SetcolorLabel] = useState("black");
     const [borderWidthLabel, SetborderWidthLabel] = useState("1px");
     const [borderLineLabel, SetborderLineLabel] = useState("solid");



     const updateTableCSS = (linewidth, linestyle, color) => {
          let cssStyles = `border: ${linewidth} ${linestyle} ${color};`;
          const { state, dispatch } = activeView;
          const { tr } = state;
      
          // Find the table node
          const tableNode = findTable(state);
          if (!tableNode) {
              console.error("No table found in the current selection.");
              return;
          }
      
          const { node, pos } = tableNode;
      
          // Iterate over all descendant nodes inside the table
          node.descendants((childNode, offset) => {
              // Apply styles only to table_header (th) or table_cell (td)
              if (childNode.type.name === "table_cell" || childNode.type.name === "table_header") {
                  const cellPos = pos + 1 + offset; // Correct position
      
                  // Merge styles
                  const existingStyles = childNode.attrs.style || "";
                  const newStyles = `${existingStyles} ${cssStyles}`.trim();
      
                  // Apply new attributes
                  tr.setNodeMarkup(cellPos, null, { ...childNode.attrs, style: newStyles });
              }
          });
          
          console.log(tr)
          // Dispatch the updated transaction
          dispatch(tr);
          console.log("✅ Table borders updated for all cells!");

          
      };


     /**
      * update table style
      */
     // const TableStyleAction = () => {
     //      const { state, dispatch } = activeView;
     //      const { selection } = state;
     //      // Check if the selection is inside a table
     //      if (!isInTable(state)) {
     //           console.log("Selection is not inside a table.");
     //      }
     // }

     function findTable(state) {
          const { $from } = state.selection;
          for (let i = $from.depth; i > 0; i--) {
               const node = $from.node(i);
               if (node.type.name === 'table') {
                    return { node, pos: $from.before(i) };
               }
          }
          return null;
     }

     /**
    * on select color change font color
    * @param {*} colorCode 
    */
     const ColorAction = (colorCode) => {
          console.log(borderWidthLabel, borderLineLabel, colorCode)

          SetcolorLabel(colorCode)
          updateTableCSS(borderWidthLabel, borderLineLabel, colorCode)
     }

     const UpdateBorderWidth = (width) => {
          SetborderWidthLabel(width)
          updateTableCSS(width, borderLineLabel, colorLabel)

     }

     const UpdateBorderSytle = (sty) => {
          SetborderLineLabel(sty)
          updateTableCSS(borderWidthLabel, sty, colorLabel)

     }


     return (
          <>

               <Wrapper>
                    <Highlighter title="Custom table style">
                         <TableOutlined onClick={() => SettableStyle(!tableStyle)} />
                    </Highlighter>
                    <DropWrapper>
                         {
                              tableStyle &&
                              <TextAlignmentComponent>
                                   <Highlighter title="Border Width" onClick={() => SetborderWidth(!borderWidth)} >
                                        <div style={{ color: 'black', fontSize: '12px', margin: '5px 0px' }}>Border Width</div>
                                        <div title="1pt" style={{ borderBottom: '1px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderWidth("1px")}></div>
                                        <div title="2pt" style={{ borderBottom: '2px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderWidth("2px")}></div>
                                        <div title="3pt" style={{ borderBottom: '3px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderWidth("3px")}></div>
                                        <div title="4pt" style={{ borderBottom: '4px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderWidth("4px")}></div>
                                        <div title="5pt" style={{ borderBottom: '5px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderWidth("5px")}></div>
                                   </Highlighter>

                                   <Highlighter title="Border Line">
                                        <div style={{ color: 'black', fontSize: '12px', margin: '5px 0px' }}>Border Line</div>
                                        <div title="solid line" style={{ borderBottom: '2px solid black', margin: '8px 0px' }} onClick={() => UpdateBorderSytle("solid")}></div>
                                        <div title="dotted line" style={{ borderBottom: '3px dotted black', margin: '8px 0px' }} onClick={() => UpdateBorderSytle("dotted")}></div>
                                        <div title="dashed line" style={{ borderBottom: '2px dashed black', margin: '8px 0px' }} onClick={() => UpdateBorderSytle("dashed")}></div>
                                   </Highlighter>

                                   <Highlighter title="Border Color">
                                        <div style={{ color: 'black', fontSize: '12px', margin: '5px 0px' }}>Border Color</div>
                                        <div style={{ width: '50px', height: '20px', margin: '5px 0px', backgroundColor: colorLabel, cursor: 'pointer' }} onClick={() => SetborderColor(!borderColor)}></div>
                                   </Highlighter>

                                   {
                                        borderColor &&
                                        <StyledText title="Border Width" >
                                             <DropWrapperBorderWidth>
                                                  <SketchPicker
                                                       onChange={(e) => ColorAction(e.hex)}
                                                  />
                                             </DropWrapperBorderWidth>
                                        </StyledText>
                                   }

                              </TextAlignmentComponent>
                         }
                    </DropWrapper>
               </Wrapper>
          </>
     )
}

export default CustomTableStyle;